import { useId } from 'react'
import classNames from 'classnames'

import { EMPTY_FUNCTION } from '../../../../constants/common'
import { getQaSelector } from '../../../../utils/common'
import { Radio, RADIO_SIZE } from '../../../Radio'
import { getIsGretaAIChatFinanceSource } from '../../GretaAIChat.utils.source'

import { QA_NAME_GRETA_AI_CHAT_SOURCE_PICKER_CARD } from './GretaAIChatSourcePickerCard.constants'
import { GretaAIChatSourcePickerCardLabel } from './GretaAIChatSourcePickerCardLabel'

import * as styles from './GretaAIChatSourcePickerCard.module.css'

function GretaAIChatSourcePickerCard({
  disabled = false,
  isFinanceNew = false,
  name,
  selectedSource,
  source,
  onChange = EMPTY_FUNCTION,
}) {
  const id = useId()

  const isFinance = getIsGretaAIChatFinanceSource(source)
  const isNew = isFinanceNew && isFinance
  const isSelected = source === selectedSource

  const cardClassName = classNames(styles.card, {
    [styles.finance]: isFinance,
    [styles.selected]: isSelected,
  })

  const qaProps = getQaSelector({
    context: source,
    value: QA_NAME_GRETA_AI_CHAT_SOURCE_PICKER_CARD,
  })

  return (
    <Radio
      checked={isSelected}
      className={styles.radio}
      containerProps={{ ...qaProps, className: cardClassName }}
      disabled={disabled}
      id={id}
      label={
        <GretaAIChatSourcePickerCardLabel
          isNew={isNew}
          isSelected={isSelected}
          source={source}
        />
      }
      labelProps={{ className: styles.label }}
      name={name}
      size={RADIO_SIZE.small}
      value={source}
      onChange={onChange}
    />
  )
}

export default GretaAIChatSourcePickerCard
